export default __webpack_public_path__ + "static/media/medals1.63340aeb.svg";